import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from './axios';
import { handleErrorToast } from '../../utils/ReusableFunctions';
import Dashboardnavbar from '../../layout/Navbar/Navbar';
import { ToastContainer, toast } from "react-toastify";
import { ArrowBullet } from "../../utils/ReusableSVGs";
import { AddTaskActivity, UpdateTaskActivity, DeleteTaskActivity, AddDailyProgress, EditDailyProgress, DeleteDailyProgress, ViewDailyProgress } from './AllProjectdetailsmodal';

const TaskActivtyDetailsPage = () => {
    const location = useLocation();
    const TaskDetails = location.state?.Task ? location.state?.Task : null;
    const TaskID = location.state?.Task?.id ? location.state?.Task?.id : location?.state?.Task;
    const [buffer, setBuffering] = useState(false);
    const [taskActivityDetails, setTaskActivityDetails] = useState([]);
    const [vendorsList, setVendorsList] = useState([]);
    const [employeeList, setEmployeeList] = useState([]);
    const [teamsList, setTeamsList] = useState([]);

    const getTaskActivity = async () => {
        setBuffering(true);
        try {
            const response = await axios.get(`${BASE_URL}/project_details/activityfilterbytask/${TaskID}/`);
            setTaskActivityDetails(response.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    const getProgressRecords = async (id) => {
        setBuffering(true);
        try {
            const response = await axios.get(`${BASE_URL}/project_details/dailyprogrerecordfilterbyactivity/${id}/`);
            setTaskActivityDetails(response.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };
    const getTaskActivityFilters = async () => {
        setBuffering(true);
        try {
            const emp = await axios.get(`${BASE_URL}/project_details/empfilterbysubcompany/${TaskDetails.sub_company || "null"}/`);
            setEmployeeList(emp.data);
            const vendor = await axios.get(`${BASE_URL}/project_details/vendorlist/${TaskDetails.sub_company || "null"}/`);
            setVendorsList(vendor.data);
            const team = await axios.get(`${BASE_URL}/project_details/approvalteam/`);
            setTeamsList(team.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        if (TaskID != undefined && TaskID != "") {
            getTaskActivity();
            getTaskActivityFilters();
        }
    }, [TaskID]);

    const formatDecimal = (value) => {
        if (value === null || value === undefined) return '-';
        return parseFloat(value).toFixed(2);
    };

    // Simple function to determine if an activity is a parent
    const isParentActivity = (activity) => {
        return activity.sub_activities && activity.sub_activities.length > 0;
    };

    // Flatten all activities including sub-activities
    const getAllActivities = () => {
        const allActivities = [];

        taskActivityDetails.forEach(activity => {
            // Add parent activity
            allActivities.push(activity);

            // Add its sub-activities if they exist
            if (activity.sub_activities && activity.sub_activities.length > 0) {
                activity.sub_activities.forEach(subActivity => {
                    allActivities.push(subActivity);
                });
            }
        });

        return allActivities;
    };

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false}
                newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <Dashboardnavbar name={`Daily Progress Report`} url="Tasks" />

            <div className="content-tabs">
                <div className="info-box-div-bg">
                    <div className="heading-bg-color-white">
                        <div className="jd-heading-outer-flex">
                            <h2 className="jd-heading-main font-weight600 font-size-heading">
                                Task : "{TaskDetails?.task_name || 'Task Name Not Available'}"
                            </h2>
                            <AddTaskActivity taskID={TaskID} taskActivities={taskActivityDetails} getActivityList={getTaskActivity} employees={employeeList} vendors={vendorsList} approvalTeams={teamsList} />
                        </div>
                    </div>

                    <div className='scroll-container-table'>
                        <div>
                            <table className="table-css">
                                <thead className="table-heading">
                                    <tr className="custom-table-head-tr">
                                        <th className="table-heading-text">S. No</th>
                                        <th className="table-heading-text">Activity</th>
                                        <th className="table-heading-text">Unit</th>
                                        <th className="table-heading-text">Scope Qty</th>
                                        <th className="table-heading-text">Completed Upto</th>
                                        <th className="table-heading-text">Balance</th>
                                        <th className="table-heading-text">Target of Month</th>
                                        <th className="table-heading-text">Achieved This Month</th>
                                        <th className="table-heading-text">Shortfall/Excess</th>
                                        <th className="table-heading-text">Target for Day</th>
                                        <th className="table-heading-text">Achieved Today</th>
                                        <th className="table-heading-text">Shortfall/Excess Today</th>
                                        <th className="table-heading-text">Cumm. Target</th>
                                        <th className="table-heading-text">Cumm. Achieved</th>
                                        <th className="table-heading-text">Cumm. Shortfall/Excess</th>
                                        <th className="table-heading-text">Remarks</th>
                                        <th className="table-heading-text">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {buffer ? (
                                        <tr>
                                            <td colSpan="17" className="text-center">
                                                <div className="spinner-bgdatil"></div>
                                            </td>
                                        </tr>
                                    ) : taskActivityDetails.length === 0 ? (
                                        <tr>
                                            <td colSpan="17" className="text-center">
                                                No activities found
                                            </td>
                                        </tr>
                                    ) : (
                                        taskActivityDetails.map((activity, index) => {
                                            const isParent = !activity.parent_activity;
                                            const hasChildren = activity.sub_activities && activity.sub_activities.length > 0;
                                            const daysInMonth = activity.start_date && activity.end_date ?
                                                Math.ceil((new Date(activity.end_date) - new Date(activity.start_date)) / (1000 * 60 * 60 * 24)) : 30;

                                            return (
                                                <React.Fragment key={activity.id}>
                                                    {/* Parent Activity Row */}
                                                    <tr className="custom-table-head-td" style={{
                                                        backgroundColor: '#f5f5f5',
                                                        fontWeight: '500'
                                                    }}>
                                                        <td className="table-body">{index + 1}</td>
                                                        <td className="table-body">
                                                            {/* <span style={{ marginRight: '8px' }}>▶</span> */}
                                                            {activity.name || 'Unnamed Activity'}
                                                        </td>
                                                        <td className="table-body">{activity.unit || '-'}</td>
                                                        <td className="table-body text-center">{formatDecimal(activity.scope_quantity)}</td>
                                                        <td className="table-body text-center">{formatDecimal(activity.completed_till_end)}</td>
                                                        <td className="table-body text-center">
                                                            {formatDecimal((parseFloat(activity.scope_quantity) || 0) - (parseFloat(activity.completed_till_end) || 0))}
                                                        </td>
                                                        <td className="table-body text-center">{formatDecimal(activity.target_of_month)}</td>
                                                        <td className="table-body text-center">{formatDecimal(activity.achieved_this_month)}</td>
                                                        <td className="table-body text-center">
                                                            {formatDecimal((parseFloat(activity.target_of_month) || 0) - (parseFloat(activity.achieved_this_month) || 0))}
                                                        </td>
                                                        <td className="table-body text-center">
                                                            {formatDecimal((parseFloat(activity.target_of_month) || 0) / daysInMonth)}
                                                        </td>
                                                        <td className="table-body text-center">
                                                            {formatDecimal((parseFloat(activity.achieved_this_month) || 0) / daysInMonth)}
                                                        </td>
                                                        <td className="table-body text-center">
                                                            {formatDecimal(
                                                                ((parseFloat(activity.target_of_month) || 0) - (parseFloat(activity.achieved_this_month) || 0)) / daysInMonth
                                                            )}
                                                        </td>
                                                        <td className="table-body text-center">
                                                            {formatDecimal(
                                                                (parseFloat(activity.completed_till_end) || 0) + (parseFloat(activity.target_of_month) || 0)
                                                            )}
                                                        </td>
                                                        <td className="table-body text-center">
                                                            {formatDecimal(
                                                                (parseFloat(activity.completed_till_end) || 0) + (parseFloat(activity.achieved_this_month) || 0)
                                                            )}
                                                        </td>
                                                        <td className="table-body text-center">
                                                            {formatDecimal(
                                                                ((parseFloat(activity.completed_till_end) || 0) + (parseFloat(activity.target_of_month) || 0)) -
                                                                ((parseFloat(activity.completed_till_end) || 0) + (parseFloat(activity.achieved_this_month) || 0))
                                                            )}
                                                        </td>
                                                        <td className="table-body">{activity.remarks || '-'}</td>
                                                        <td className="table-body">
                                                            <div className="flex-row">
                                                                <UpdateTaskActivity activity={activity} getActivityList={getTaskActivity} employees={employeeList} vendors={vendorsList} approvalTeams={teamsList} />
                                                                <DeleteTaskActivity activity={activity} getActivityList={getTaskActivity} />
                                                                <AddDailyProgress activityID={activity} getProgressRecords={getProgressRecords} />
                                                                <ViewDailyProgress i={activity} getProgressRecords={getProgressRecords} />
                                                            </div>
                                                        </td>
                                                    </tr>

                                                    {/* Child Activities */}
                                                    {hasChildren && activity.sub_activities.map((subActivity, subIndex) => {
                                                        const subDaysInMonth = subActivity.start_date && subActivity.end_date ?
                                                            Math.ceil((new Date(subActivity.end_date) - new Date(subActivity.start_date)) / (1000 * 60 * 60 * 24)) : 30;


                                                        return (
                                                            <tr
                                                                key={subActivity.id}
                                                                className="custom-table-head-td"
                                                                style={{ backgroundColor: 'white' }}
                                                            >
                                                                <td className="table-body" style={{ paddingLeft: '30px' }}>
                                                                    {index + 1}.{subIndex + 1}
                                                                </td>
                                                                <td className="table-body" style={{ paddingLeft: '30px' }}>
                                                                    {/* <span style={{ marginRight: '8px' }}>•</span> */}
                                                                    {subActivity.name || 'Unnamed Sub-activity'}
                                                                </td>
                                                                <td className="table-body">{subActivity.unit || '-'}</td>
                                                                <td className="table-body text-center">{formatDecimal(subActivity.scope_quantity)}</td>
                                                                <td className="table-body text-center">{formatDecimal(subActivity.completed_till_end)}</td>
                                                                <td className="table-body text-center">
                                                                    {formatDecimal((parseFloat(subActivity.scope_quantity) || 0) - (parseFloat(subActivity.completed_till_end) || 0))}
                                                                </td>
                                                                <td className="table-body text-center">{formatDecimal(subActivity.target_of_month)}</td>
                                                                <td className="table-body text-center">{formatDecimal(subActivity.achieved_this_month)}</td>
                                                                <td className="table-body text-center">
                                                                    {formatDecimal((parseFloat(subActivity.target_of_month) || 0) - (parseFloat(subActivity.achieved_this_month) || 0))}
                                                                </td>
                                                                <td className="table-body text-center">
                                                                    {formatDecimal((parseFloat(subActivity.target_of_month) || 0) / subDaysInMonth)}
                                                                </td>
                                                                <td className="table-body text-center">
                                                                    {formatDecimal((parseFloat(subActivity.achieved_this_month) || 0) / subDaysInMonth)}
                                                                </td>
                                                                <td className="table-body text-center">
                                                                    {formatDecimal(
                                                                        ((parseFloat(subActivity.target_of_month) || 0) - (parseFloat(subActivity.achieved_this_month) || 0)) / subDaysInMonth
                                                                    )}
                                                                </td>
                                                                <td className="table-body text-center">
                                                                    {formatDecimal(
                                                                        (parseFloat(subActivity.completed_till_end) || 0) + (parseFloat(subActivity.target_of_month) || 0)
                                                                    )}
                                                                </td>
                                                                <td className="table-body text-center">
                                                                    {formatDecimal(
                                                                        (parseFloat(subActivity.completed_till_end) || 0) + (parseFloat(subActivity.achieved_this_month) || 0)
                                                                    )}
                                                                </td>
                                                                <td className="table-body text-center">
                                                                    {formatDecimal(
                                                                        ((parseFloat(subActivity.completed_till_end) || 0) + (parseFloat(subActivity.target_of_month) || 0)) -
                                                                        ((parseFloat(subActivity.completed_till_end) || 0) + (parseFloat(subActivity.achieved_this_month) || 0))
                                                                    )}
                                                                </td>
                                                                <td className="table-body">{subActivity.remarks || '-'}</td>
                                                                <td className="table-body">
                                                                    <div className="flex-row">
                                                                        <UpdateTaskActivity activity={subActivity} getActivityList={getTaskActivity} employees={employeeList} vendors={vendorsList} approvalTeams={teamsList} />
                                                                        <DeleteTaskActivity activity={subActivity} getActivityList={getTaskActivity} />
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                </React.Fragment>
                                            )
                                        })
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export { TaskActivtyDetailsPage };